module.exports = __webpack_public_path__ + "img/tejal-yoga_thumbnail.3da9eb19.jpg";